import React from 'react';
import { Icon, IconSize } from '@/components/common/Icon';
import { Tooltip } from '@/components/common/Tooltip';
import { useFullscreenStore } from '@/components/layout/NavigationLayout/FullscreenStore';
import { useTranslations } from '@/core/translations';
import { Colors } from '@/styles/colors';
import styles from './Link.module.scss';

interface FullscreenNavItemProps {
  isOpen: boolean;
}

export const FullscreenNavItem: React.FC<FullscreenNavItemProps> = ({ isOpen }) => {
  const t = useTranslations('general');
  const setFullscreen = useFullscreenStore((state) => state.setFullscreen);
  const label = t('enterFullscreen');

  return (
    <Tooltip label={label} placement="right" isDisabled={isOpen}>
      <button type="button" aria-label={label} className={styles.root} onClick={() => setFullscreen(true)}>
        <div className={styles.iconWrapper}>
          <Icon name="FullscreenIcon" size={IconSize.s24} fillColor={Colors.Neutral} />
        </div>
        {isOpen && (
          <div className={styles.titleWrapper}>
            <div className={styles.title}>{label}</div>
          </div>
        )}
      </button>
    </Tooltip>
  );
};
